<template>
  <div class="container">
    <div class="row">
      <static-info-field
        label="Vendor"
        :value="subscription.account_subscription.vendor"
      />

      <static-info-field
        label="Status"
        :value="subscription.account_subscription.status"
        class="status"
        :class="{
          statusActive: ['Promo', 'Active', 'Trial'].includes(subscription.account_subscription.status),
          statusExpired: ['Expired', 'Canceled', 'Refund', 'Fraud', 'Transferred'].includes(subscription.account_subscription.status),
          statusShrug: ['UnknownSubscriptionStatus', 'Pending', 'BillingRetryPeriod', 'GracePeriod', 'Paused'].includes(subscription.account_subscription.status),
        }"
      />

      <static-info-field
        v-if="subscription.account_subscription.name"
        label="Name"
        :value="subscription.account_subscription.name"
      />

      <md-button
        v-if="canCancelSubscription"
        class="dangerButton"
        @click="onCancelButtonClick"
      >
        Cancel subscription
      </md-button>

      <md-button
        v-if="subscription.account_subscription.status !== 'Transferred'"
        @click="isTransferDialogOpen = true"
      >
        Transfer
      </md-button>
    </div>

    <div class="row">
      <static-info-field
        v-if="subscription.account_subscription.sku"
        label="SKU"
        :value="subscription.account_subscription.sku"
      />

      <static-info-field
        v-if="subscription.account_subscription.app_identity"
        label="App Identity"
        :value="subscription.account_subscription.app_identity"
      />

      <static-info-field
        v-if="subscription.account_subscription.referrer"
        label="Referrer"
        :value="subscription.account_subscription.referrer"
      />

      <static-info-field
        v-if="subscription.account_subscription.product_id"
        label="Product ID"
        :value="subscription.account_subscription.product_id"
      />
    </div>

    <div class="row">
      <static-info-field
        label="Created at"
        :value="(new Date(subscription.account_subscription.created_at_timestamp)).toUTCString()"
      />

      <static-info-field
        label="Expiration date"
        :value="(new Date(subscription.account_subscription.expiration_date)).toUTCString()"
      />
    </div>

    <div
      v-if="subscription.account_subscription.price.currency && subscription.account_subscription.price.amount"
      class="row"
    >
      <static-info-field
        label="Price"
        :value="`${subscription.account_subscription.price.amount} ${subscription.account_subscription.price.currency}`"
      />
    </div>

    <div class="row">
      <static-info-field
        v-if="subscription.account_subscription.subscription_id"
        label="Subscription ID"
        :value="subscription.account_subscription.subscription_id"
      />

      <static-info-field
        v-if="subscription.account_subscription.vendor_subscription_id"
        label="Vendor subscription ID"
        :value="subscription.account_subscription.vendor_subscription_id"
      />

      <static-info-field
        v-if="subscription.account_subscription.vendor === 'android'"
        label="Android Order ID"
        :value="subscription.android_subscription.order_id"
      />

      <static-info-field
        v-if="subscription.account_subscription.vendor === 'chargebee'"
        label="Chargebee Subscription ID"
        :value="subscription.chargebee_subscription.subscription_id"
      />
      <static-info-field
        v-if="subscription.account_subscription.vendor === 'chargebee'"
        label="Chargebee Customer ID"
        :value="subscription.chargebee_subscription.customer_id"
      />

      <static-info-field
        v-if="subscription.account_subscription.vendor === 'platform_payment'"
        label="Platform Payment ID"
        :value="subscription.platform_payment_subscription.platform_payment_id"
      />
      <static-info-field
        v-if="subscription.account_subscription.vendor === 'platform_payment'"
        label="Platform Owner ID"
        :value="subscription.platform_payment_subscription.owner_id"
      />

      <static-info-field
        v-if="subscription.account_subscription.vendor === 'promocode'"
        label="Promocode ID"
        :value="subscription.promocode.id"
      />
      <static-info-field
        v-if="subscription.account_subscription.vendor === 'promocode'"
        label="Promocode Code"
        :value="subscription.promocode.code"
      />
    </div>

    <prism-editor
      v-if="subscription.account_subscription.vendor === 'apple'"
      v-model="formattedAppleReceipt"
      label="Apple Receipt"
      language="json"
      :readonly="true"
    />

    <transfer-subscription-dialog
      :is-open.sync="isTransferDialogOpen"
      :current-holder-user-id="'qqw'"
      :subscription="subscription"
    />
  </div>
</template>
<script>
import StaticInfoField from "./StaticInfoField";
import PrismEditor from "vue-prism-editor";
import TransferSubscriptionDialog from "./TransferSubscriptionDialog.vue";

export default {
    components: { StaticInfoField, PrismEditor, TransferSubscriptionDialog },
    props: {
      subscription: { type: Object, default: () => ({}) }
    },
    data() {
      return {
        isTransferDialogOpen: false,
      };
    },
    computed: {
      canCancelSubscription() {
        return ["Promo", "Active", "Trial", "Pending", "BillingRetryPeriod", "GracePeriod"].includes(this.subscription.account_subscription.status)
          && ["stripe", "platform_payment", "promocode", "chargebee"].includes(this.subscription.account_subscription.vendor);
      },
      formattedAppleReceipt() {
        return this.subscription.apple_subscription.receipt ? JSON.stringify(JSON.parse(this.subscription.apple_subscription.receipt), null, 4) : "";
      }
    },
    methods: {
      onCancelButtonClick () {
        this.$emit("subscriptionCancel", this.subscription.account_subscription.subscription_id);
      }
    }
  };
</script>
<style lang="scss">
  .container {
    border: 1px solid #999;
    border-radius: 8px;
    padding: 4px;
    flex-direction: column;

    & + & {
      margin: 16px 0 0;
    }
  }

  .row {
    display: flex;
    align-items: center;
    column-gap: 16px;
  }

  .status {
    span + span {
      font-weight: 600;
    }

    &Active {
      color: #19b053;
    }

    &Expired {
      color: #c43714;
    }

    &Shrug {
      color: #f2d52e;
    }
  }

  .dangerButton {
    background-color: #ad1457 !important;
    height: 36px;
  }
</style>
